// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productivity-calc-dialog .p-dialog-content {
  padding-top: 0.5rem;
}

.productivity-calc-dialog__section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.productivity-calc-dialog__section-label {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--text-color);
}

.productivity-calc-dialog__dropdown-skeleton {
  width: 100%;
  pointer-events: none;
}

.productivity-calc-dialog__dropdown-skeleton .p-skeleton {
  width: 100% !important;
}

.productivity-calc-dialog__tags-skeleton {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
  padding: 0.125rem 0;
}

.productivity-calc-dialog__employee-picker-empty {
  color: var(--text-color-secondary);
  font-size: 0.875rem;
  padding: 0.75rem;
  text-align: center;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
}

.productivity-calc-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.5rem;
  margin-top: 0.25rem;
  border-top: 1px solid var(--surface-border);
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/EmployeeProductivityCalcDialog.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C","sourcesContent":[".productivity-calc-dialog .p-dialog-content {\n  padding-top: 0.5rem;\n}\n\n.productivity-calc-dialog__section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.productivity-calc-dialog__section-label {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--text-color);\n}\n\n.productivity-calc-dialog__dropdown-skeleton {\n  width: 100%;\n  pointer-events: none;\n}\n\n.productivity-calc-dialog__dropdown-skeleton .p-skeleton {\n  width: 100% !important;\n}\n\n.productivity-calc-dialog__tags-skeleton {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.125rem 0;\n}\n\n.productivity-calc-dialog__employee-picker-empty {\n  color: var(--text-color-secondary);\n  font-size: 0.875rem;\n  padding: 0.75rem;\n  text-align: center;\n  border: 1px solid var(--surface-border);\n  border-radius: 6px;\n}\n\n.productivity-calc-dialog__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding-top: 0.5rem;\n  margin-top: 0.25rem;\n  border-top: 1px solid var(--surface-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
